import styled from "styled-components";

import breakpoints from "../../../styles/breakpoints";
import { colors, fonts } from "../../../styles/variables";

export const Card = styled.article<{ $isInCollection: boolean }>`
  flex: ${({ $isInCollection }) => ($isInCollection ? "0 0 300px" : "initial")};
  width: 100%;
  min-width: 0;
  background-color: ${colors.white};

  ${breakpoints.xsDown} {
    flex-basis: ${({ $isInCollection }) => ($isInCollection ? "250px" : "auto")};
  }
`;

export const Cover = styled.img`
  display: block;
  width: 100%;
  aspect-ratio: 1;
  object-fit: contain;
`;

export const Footer = styled.div`
  border: 1px solid ${colors.black};
  padding: 12px;
`;

export const Name = styled.h3`
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 24px;
  line-height: 26px;
  margin: 0 0 12px;
  min-height: 52px;

  ${breakpoints.smDown} {
    font-size: 20px;
    line-height: 22px;
    min-height: 44px;
  }
`;

export const Price = styled.span`
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 25px;
  line-height: 28px;
`;

export const StockLabel = styled.span`
  display: block;
  font-size: 12px;
  margin-top: 8px;
`;

export const PanelBottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

// Mirrors the ADD button on the wine SpecialPackEditionCard
export const AddButton = styled.button`
  flex-shrink: 0;
  padding: 9px 10px;
  border: 1px solid ${colors.black};
  background-color: ${colors.black};
  color: ${colors.white};
  font-family: ${fonts.fontBauMedium};
  font-size: 10px;
  font-weight: bold;
  line-height: 1.5;
  text-align: center;
  text-transform: uppercase;
  cursor: pointer;

  &:hover,
  &:focus {
    background-color: ${colors.white};
    color: ${colors.black};
  }

  &:disabled {
    background-color: ${colors.black};
    color: ${colors.white};
    opacity: 0.5;
    cursor: default;
  }
`;
